export default function Services() {
  const services = [
    {
      title: 'Large-Scale Estimating',
      description: 'Comprehensive cost analysis and quantity takeoffs for mega projects. Our expert team delivers accurate estimates for tall buildings, infrastructure, and complex developments.',
      icon: 'ri-calculator-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20construction%20cost%20estimating%20workspace%20with%20detailed%20spreadsheets%20and%20blueprints%20on%20modern%20desk%2C%20tall%20building%20construction%20site%20visible%20through%20window%2C%20clean%20minimalist%20office%20environment%20with%20warm%20lighting%2C%20business%20professional%20atmosphere%20showing%20precision%20and%20accuracy&width=600&height=600&seq=service-est-001&orientation=squarish',
      color: 'orange'
    },
    {
      title: 'Advanced BIM Modeling',
      description: 'State-of-the-art Building Information Modeling for coordination, clash detection, and visualization. Expertise in Revit and advanced 3D modeling for all project types.',
      icon: 'ri-building-line',
      image: 'https://readdy.ai/api/search-image?query=Futuristic%20BIM%203D%20wireframe%20model%20of%20modern%20skyscraper%20on%20dark%20navy%20blue%20background%20with%20glowing%20green%20neon%20lines%2C%20digital%20construction%20technology%20visualization%2C%20holographic%20architectural%20rendering%20showing%20structural%20elements%20and%20MEP%20systems%2C%20high-tech%20professional%20presentation&width=600&height=600&seq=service-bim-001&orientation=squarish',
      color: 'green'
    },
    {
      title: 'P6 & MS Project Scheduling',
      description: 'Expert project scheduling using Primavera P6 and Microsoft Project. Critical path analysis, resource allocation, and timeline optimization for complex construction projects.',
      icon: 'ri-calendar-schedule-line',
      image: 'https://readdy.ai/api/search-image?query=Modern%20data%20center%20construction%20site%20with%20visible%20Gantt%20chart%20overlay%20and%20timeline%20graphics%2C%20organized%20construction%20progress%20with%20workers%20and%20equipment%2C%20professional%20project%20management%20visualization%20showing%20scheduling%20and%20coordination%2C%20clean%20industrial%20environment%20with%20structured%20workflow&width=600&height=600&seq=service-sch-001&orientation=squarish',
      color: 'orange'
    },
    {
      title: 'Fire Protection Services',
      description: 'Complete fire protection engineering and estimating for fire sprinkler systems and non-water based suppression systems. Expertise across commercial, industrial, data centers, and high-rise buildings.',
      icon: 'ri-fire-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20fire%20sprinkler%20system%20installation%20in%20large%20commercial%20building%20with%20red%20pipes%20and%20sprinkler%20heads%20mounted%20on%20ceiling%2C%20industrial%20fire%20suppression%20infrastructure%20with%20organized%20pipe%20network%20and%20fittings%2C%20clean%20modern%20construction%20environment%20showing%20precision%20fire%20protection%20engineering%20work%2C%20realistic%20photographic%20style&width=600&height=600&seq=service-fire-001&orientation=squarish',
      color: 'green'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-orange-600 text-sm font-semibold uppercase tracking-wider mb-3">
            WHAT WE DO
          </p>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Comprehensive Construction Consulting
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Delivering precision and efficiency across all project phases
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              {/* Image */}
              <div className="relative h-72 w-full overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              </div>

              {/* Content */}
              <div className="p-8">
                <div className={`w-14 h-14 flex items-center justify-center rounded-full ${service.color === 'orange' ? 'bg-orange-100' : 'bg-green-100'} mb-4`}>
                  <i className={`${service.icon} text-2xl ${service.color === 'orange' ? 'text-orange-600' : 'text-green-600'}`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}